var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 161,
    viewBox: "0 0 156 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.368 70.2178C16.368 70.2178 43.7411 69.1216 49.6564 24.1262C54.9094 -15.8341 101.068 2.35437 114.41 18.2835C131.694 38.9183 122.481 74.4146 144.84 78.8988C167.199 83.383 152.598 133.239 118.658 128.467C76.438 122.531 86.6528 147.202 73.9786 157.644C64.8826 165.139 27.5855 157.925 26.3425 130.719C25.2964 107.826 15.6397 107.899 8.7949 105.303C-1.07683 101.559 -7.29711 74.4453 16.368 70.2178Z",
    fill: "#01C296",
    fillOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114.229 120.188L87.3359 93.6143L82.0107 99.0035L108.904 125.578L114.229 120.188Z",
    fill: "#BDBDBD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.502 127.329L103.579 106.654C103.463 106.539 103.275 106.54 103.16 106.657L95.2408 114.671C95.1257 114.788 95.1268 114.975 95.2433 115.09L116.166 135.765C116.283 135.88 116.471 135.879 116.586 135.763L124.505 127.748C124.62 127.632 124.619 127.444 124.502 127.329Z",
    fill: "#564256"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5003 106.979C82.002 106.979 97.0006 91.9805 97.0006 73.4788C97.0006 54.9771 82.002 39.9785 63.5003 39.9785C44.9986 39.9785 30 54.9771 30 73.4788C30 91.9805 44.9986 106.979 63.5003 106.979Z",
    fill: "#564256"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5004 101.513C78.9832 101.513 91.5345 88.9617 91.5345 73.4789C91.5345 57.9961 78.9832 45.4448 63.5004 45.4448C48.0176 45.4448 35.4663 57.9961 35.4663 73.4789C35.4663 88.9617 48.0176 101.513 63.5004 101.513Z",
    fill: "#EEF8F7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/NoData.eb394c548aa512081c381da06021938d.svg";
export { ForwardRef as ReactComponent };